// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PinterestOutlinedSvg from "@fishx/icons-svg/es/asn/PinterestOutlined";
import FishxIcon from '../components/FishxIcon';

var PinterestOutlined = function PinterestOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PinterestOutlinedSvg
  }));
};

PinterestOutlined.displayName = 'PinterestOutlined';
export default React.forwardRef(PinterestOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PinterestOutlined.js
// module id = 3800
// module chunks = 0